module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "abs",
    attrs: {
      "id": "modal"
    }
  }, [_c('div', {
    staticClass: "product-select rel"
  }, [_c('div', [_c('i', {
    staticClass: "close-dialog",
    on: {
      "click": function($event) {
        _vm.closeDialog(_vm.list, _vm.component);
      }
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Index")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getPosition),
      expression: "getPosition"
    }],
    attrs: {
      "id": "position",
      "type": "number"
    },
    domProps: {
      "value": (_vm.getPosition)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.getPosition = $event.target.value
      }
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("configurator.product")))]), _vm._v(" "), _vm._l((_vm.relatedProducts), function(product) {
    return (product !== null) ? _c('div', {
      key: product.id,
      staticClass: "content-product"
    }, [_c('input', {
      attrs: {
        "id": 'product_' + product.id,
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.addProduct(product, $event.target.checked);
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'product_' + product.id
      }
    }, [_vm._v(_vm._s(_vm.getTranslate(product.terms.name)))])]) : _vm._e()
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Tester")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tester),
      expression: "tester"
    }],
    attrs: {
      "type": "checkbox",
      "id": "tester"
    },
    domProps: {
      "checked": Array.isArray(_vm.tester) ? _vm._i(_vm.tester, null) > -1 : (_vm.tester)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.tester,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.tester = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.tester = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.tester = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tester"
    }
  }, [_vm._v(_vm._s(_vm.$t("configurator.messageAlert1")))])]), _vm._v(" "), _c('div', {
    staticClass: "buttonbar"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.valid
    }
  }, [_vm._v("OK")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b7859fb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/ProductSelect.vue
// module id = 3210
// module chunks = 0